import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type InsightsQuery from "./InsightsQuery";

@Model()
class InsightsKeySpokesperson extends ApplicationRecord {
  static jsonapiType = "insights_key_spokespeople";

  @Attr() booleanQuery: string;

  @Attr() color: string;

  @BelongsTo() insightsQuery: InsightsQuery;

  @Attr() label: string;
}

export default InsightsKeySpokesperson;
